import { useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { usePropertyEditMutation } from './usePropertyEditMutation';
import { FEED_OVERRIDES_TAG } from '../constants/FeedOverrideConstants';

import type { UserPropertyFeedFloorPlanEditRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export type EditFeedFloorPlanInput = Omit<UserPropertyFeedFloorPlanEditRequestDto, 'listingAlias'>;

/**
 * Edits a supplemented (ZRM) feed floor plan by rewriting its zramModel feed override. Only floor plans
 * created as overrides can be edited this way; feed-provided floor plans are read-only. The caller supplies
 * the feedModelId and field values and the listingAlias is added from the route.
 */
export const useEditFeedFloorPlan = (listingAlias: string) => {
  const { mutateAsync, isPending } = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit,
    successToastMessage: 'Floor plan updated',
    meta: {
      invalidates: [FEED_OVERRIDES_TAG, 'mf-costsAndFees'],
      context: { api: 'RentalManagerUserPropertyFeedFloorPlanWebApiHandler_edit', details: { listingAlias } },
    },
  });

  const editFeedFloorPlan = (input: EditFeedFloorPlanInput) => mutateAsync({ postData: { listingAlias, ...input } });

  return { editFeedFloorPlan, isPending };
};
